import React, { useState } from "react";

interface FormData {
  // firstName: string;
  // lastName: string;
  // email: string;
  //
  // phoneNumber: string;

  // Test Answers
  retirementStatus: string;
  estimatedSavings: string;
  mainConcerns: string;
  age: string;
  /*   state: string; */
  taxRateLongTermCare: string;
  token: string | null;
}
interface BookFormData {
  firstName: string;
  lastName: string;
  email: string;

  phoneNumber: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
}
export const HandleBookSubmit = async (
  formData: BookFormData,
  token: string,
  setIsLoading: (loading: boolean) => void,
): Promise<boolean> => {
  setIsLoading(true);
  // const eventID = token; // use this for deduplication with CAPI
  // window.fbq("track", "Lead", {
  //   content_name: "Lead Form Submit",
  //   value: 4.99,
  //   currency: "USD",
  //   eventID,
  // });
  const payload = {
    firstName: formData.firstName,
    lastName: formData.lastName,
    email: formData.email,
    phoneNumber: formData.phoneNumber,
    address: formData.address,
    token: token,
    city: formData.city,
    state: formData.state,
    zipCode: formData.zipCode,
  };
  try {
    const response = await fetch(
      "https://backend-retirement-club.vercel.app/api/book-order",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      },
    );
    const data = await response.json();
    // console.log(data);
    if (response.ok) {
      setIsLoading(false);
      return true;
    } else {
      setIsLoading(false);

      console.error("Error Submitting data:", data);

      return false;
    }
  } catch (error) {
    setIsLoading(false);

    console.error("Submission Error:", error);
    return false;
  }
};

export const HandleSubmit = async (
  formData: FormData,
  setIsLoading: (loading: boolean) => void,
): Promise<boolean> => {
  // Prevents default form submission
  setIsLoading(true);

  const payload = {
    // firstName: formData.firstName,
    // lastName: formData.lastName,
    // email: formData.email,
    //
    // phoneNumber: formData.phoneNumber,

    // Test Answers
    retirementStatus: formData.retirementStatus,
    estimatedSavings: formData.estimatedSavings,
    mainConcerns: formData.mainConcerns,
    age: formData.age,
    // state: formData.state,
    taxRateLongTermCare: formData.taxRateLongTermCare,
    token: formData.token,
  };

  try {
    const response = await fetch(
      "https://backend-retirement-club.vercel.app/api/contact-update",

      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      },
    );

    const data = await response.json();
    // console.log(data);
    if (response.ok) {
      setIsLoading(false);

      return true;
    } else {
      setIsLoading(false);

      console.error("Error Submitting data:", data);

      return false;
    }
  } catch (error) {
    setIsLoading(false);

    console.error("Submission Error:", error);
    return false;
  }
};
